const boolToYesNo = (bool) => typeof(bool) === 'boolean' ? (!!bool ? 'Yes' : 'No') : bool;

export {
	boolToYesNo
};